import { render, staticRenderFns } from "./userStatistics1.vue?vue&type=template&id=fc4be43e&scoped=true&"
import script from "./userStatistics1.vue?vue&type=script&lang=ts&"
export * from "./userStatistics1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4be43e",
  null
  
)

export default component.exports